import React, { Component } from 'react';

import { Navigate, NavLink } from 'react-router-dom';
import Cookie from 'js-cookie';
import { Config } from '../config/config';
import Menu from './Menu';
import Header from './Header';
import Footer from './Footer';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import Spinner from '../UIComponents/Spinner/Spinner';

import AddVendor from '../pages/projectTracker/AddVendor';
import EditVendor from '../pages/projectTracker/EditVendor';
import EditVendorStatus from '../pages/projectTracker/EditVendorStatus';
import LZString from 'lz-string';

class Project extends Component {
  constructor(props) {
    super(props);
    Cookie.remove('venderDetails');
    localStorage.removeItem('projectName');

    localStorage.removeItem('vendor');
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    const config = JSON.parse(Config);
    // let stores = JSON.parse(Cookie.get('stores'));
    // let wareHouses = JSON.parse(Cookie.get('warehouses'));
    let stores = JSON.parse(localStorage.getItem('storeData'));
    let wareHouses = JSON.parse(localStorage.getItem('warehouseData'));
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const userInfo = JSON.parse(decompressedData) 
    let userID = userInfo['userId'];
    let date = new Date();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);
    let year = date.getFullYear();
    var daynow = new Date();

    daynow.setDate(daynow.getDate());
    var dateStringNow = daynow.toISOString().split('T')[0];

    let title = this.props.location.state.title;

    let id = this.props.location.state.id;
    let projectStatusReport = this.props.location.state.projectStatusReport;

    var dayst = new Date();
    dayst.setDate(dayst.getDate() - 30);
    var dateString = dayst.toISOString().split('T')[0];

    this.state = {
      projectId: title,
      title: '',
      storeId: id,
      projectStatusReport: projectStatusReport,

      data: [],
      alert: '',
      incType: '',
      isFlushed: false,

      storeValue: '',
      vendorsNo: [],

      storeSelected: false,
      closure: '',
      stores,
      userID: userID,
      wareHouses,
      modalOpen: false,
      visible: false,
      tableVisible: false,
      month: month,
      day: day,
      year,
      FromDate: dateString,
      ToDate: dateStringNow,
      codeJson: [],
      redirect: null,

      noOfVendors: null,
      vendorDetail: {},
      vendorsDetails: [],
      loadVendors: [],
      vendorEditing: false,
      statusEditing: false,
      vendorData: [],
      statusData: [],
      timeIntreval: '',
      statusins: '',

      submittedByCodeJson: [],
      message: '',
      apiInterface: config['api'],
      proxyjson: [],
      loading: false,
      submittedBy: '',
      viewPo: '',
      download: false,
    };
  }

  onLoadProject = () => {
    let id = this.state.storeId;
    ApiGateWay.Get(
      this.state.apiInterface +
        '/loadProjects?storeId=' +
        id +
        '&projectId=' +
        this.state.projectId
    )
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }

        response.projectInfo.map((ins) =>
          this.setState({
            title: ins.projectName,
            storeId: ins.storeId,
          })
        );
      })
      .catch(() => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  };

  onLoadVendors = () => {
    ApiGateWay.Get(
      this.state.apiInterface +
        '/loadVendorDetails?projectId=' +
        this.state.projectId
    )
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }

        this.setState({
          loadVendors: response,

          visible: true,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  };

  editVendorDetails = (
    vendorName,
    vendorContactPerson,
    vendorEmail,
    vendorAddress,
    vendorGST,

    vendorCost,
    vendorQuotes,

    vendorSeqId
  ) => {
    this.setState({
      loading: true,
    });

    const venStat = {
      projectId: this.state.projectId,
      quoteAmount: vendorCost,
      quoteDate: vendorQuotes + 'T00:00:00.000Z',
      updateUser: this.state.userID,
      vendorGst: vendorGST,
      vendorSeqId: vendorSeqId,
    };

    //alert(JSON.stringify(venStat));
    ApiGateWay.Post(
      this.state.apiInterface + '/updateQuoteDetailsForVendor',
      venStat
    )
      .then((response) => response.json())
      .then((response) => {
        /* ApiGateWay.Post(this.state.apiInterface + "/updateQuoteDetailsForVendor", venStat)
          .then((response) => response.json())
          .then((response) => {

            alert(JSON.stringify(response));
            this.setState({
              loading: false,

            });
          })

          .catch((error) => {
            this.setState({
              loading: false,
              modalOpen: true,
              message: "Unable to retrieve the data. Please try again later!!",
            });
          }); */

        this.setState({
          //loading: false,
          vendorEditing: false,
          vendorsNo: response,
          //modalOpen: true,
          //message: 'Updated Successfully!!',
        });
        toast.success('Updated Successfully!');
        //this.onLoadVendors();
        setTimeout(() => {
          this.onLoadVendors();
        }, 1000);
      })
      .catch(() => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later!!',
        });
      });
  };

  addVendor = (
    vendorName,
    vendorEmail,
    vendorAddress,
    vendorCost,
    vendorQuotes,
    vendorContactPerson,
    vendorGST
  ) => {
    let dateFormat = 'T00:00:00.000Z';
    let temp = '';
    let daynow = new Date();
    daynow.setDate(daynow.getDate());
    let dateStringNow = daynow.toISOString().split('T')[0];
    if (vendorQuotes !== '') {
      temp = vendorQuotes + dateFormat;
    } else {
      temp = dateStringNow + dateFormat;
    }

    const vendor = {
      projectId: this.state.projectId,
      quoteAmount: vendorCost,

      quoteDate: temp,
      storeId: this.state.storeId,
      vendorAddress: vendorAddress,
      vendorContactPerson: vendorContactPerson,
      vendorCreatedBy: this.state.userID,
      vendorEmail: vendorEmail,
      vendorGst: vendorGST,
      vendorName: vendorName,
    };

    this.setState({
      loading: true,
    });

    ApiGateWay.Post(this.state.apiInterface + '/addVendorsToProject', vendor)
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          // loading: false,
          vendorsNo: response,
          //modalOpen: true,
          //message: 'Vendor added Successfully!!',
        });
        toast.success('Vendor added successfully!');
        //this.onLoadVendors();
        setTimeout(() => {
          this.onLoadVendors();
        }, 1000);
      })
      .catch(() => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later!!',
        });
      });
  };

  handleEditVendor = (vendor) => {
    this.setState({
      vendorEditing: true,
      vendorData: vendor,
    });
  };
  setEditing = (x) => {
    this.setState({
      vendorEditing: x,
    });
  };
  setStaEditing = (x) => {
    this.setState({
      statusEditing: x,
    });
  };

  handleEditStatus = (vendor) => {
    this.setState({
      statusEditing: true,
      statusData: vendor,
    });
  };

  viewPo = (vendor) => {
    this.setState({
      download: true,
    });
    const config = JSON.parse(Config);
    let headers = {
      Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
      'Access-Control-Allow-Origin': '*',
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    };

    axios
      .get(
        process.env.REACT_APP_UPLOAD_DOWNLOAD +
          config['api'] +
          '/download?objectId=' +
          vendor.poLink,
        {
          headers: headers,
          responseType: 'blob',
        }
      )
      .then((response) => {
        //Create a Blob from the PDF Stream

        var re = /(?:\.([^.]+))?$/;

        var ext = re.exec(vendor.poLink)[1]; // "txt"
        const MimeTypesMap = {
          png: 'image/png',
          gif: 'image/gif',
          jpg: 'image/jpg',
          jpeg: 'image/jpeg',
          pdf: 'application/pdf',
          mp4: 'video/mp4',
          doc: 'application/msword',
          docx:
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          ppt: 'application/vnd.ms-powerpoint',
          xlsx:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        };

        const mimeType = MimeTypesMap[ext];

        const file = new Blob([response.data], { type: mimeType });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        if (mimeType === 'application/pdf') {
          window.open(fileURL, '_blank');
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', vendor.poLink); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
        this.setState({
          download: false,
        });
      })
      .catch(() => {});
  };

  handlePo = (vendor, projectName) => {
    localStorage.setItem('vendor', JSON.stringify(vendor));
    localStorage.setItem('projectName', JSON.stringify(projectName));
  };
  goBack = () => {
    this.setState({
      redirect: '/projectTracker',
    });
  };

  editStatusDetails = (prID, sqID, stat) => {
    const venstat = {
      projectId: prID,
      updateUser: this.state.userID,
      vendorSeqId: sqID,
      vendorStatus: stat,
    };
    //alert(JSON.stringify(stat))
    ApiGateWay.Post(
      this.state.apiInterface + '/updateProjectVendorStatus',
      venstat
    )
      .then((response) => response.json())
      .then(() => {
        this.setState({
          //loading: false,
          statusEditing: false,
          //modalOpen: true,
          // message: 'Updated Successfully!!',
        });
        toast.success('Status updated!');
        //this.onLoadVendors();
        setTimeout(() => {
          this.onLoadVendors();
        }, 1000);

        //this.onLoadVendors();
      })
      .catch(() => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later!!',
        });
      });
  };

  componentDidMount() {
    this.setState({
      loading: true,
    });
    if (this.props.location.setReload) {
      //window.location.reload();
    }

    this.onLoadProject();

    this.onLoadVendors();
  }

  render() {
    if (this.state.redirect) {
      return (
       
        <Navigate
        to={this.state.redirect}
        state={{
          id: this.state.storeId,
          fromDate: this.props.location.state.fromDate,
          toDate: this.props.location.state.toDate
        }}
      />
      );
    }
    const { loading, modalOpen, message } = this.state;
    let addvendor = [];
    let temp = '';
    let temp1 = '';
    if (
      this.state.loadVendors.vendorsInfo &&
      this.state.loadVendors.vendorsInfo.length > 0
    ) {
      addvendor = this.state.loadVendors.vendorsInfo.map((insert) => {
        return (
          <tr style={{ textAlign: 'center' }} key={insert.vendorSeqId}>
            {this.state.projectStatusReport === 'Completed' ||
            insert.poStatus === 'Yes' ? (
              <td>{insert.vendorName}</td>
            ) : (
              <td
                className='col-md-2'
                onClick={() => this.handleEditVendor(insert)}
              >
                <a
                  style={{
                    textDecoration: 'none',
                    cursor: 'pointer',
                  }}
                >
                  {insert.vendorName}
                </a>
              </td>
            )}
            <td>{insert.vendorEmail}</td>
            <td>{insert.vendorContactPerson}</td>
            <td>{insert.vendorAddress}</td>
            <td>{insert.vendorGst}</td>
            <td>{insert.quoteAmount}</td>
            <td>{insert.quoteDate}</td>
            <td>{insert.vendorCreatedBy}</td>
            <td>{(temp = insert.vendorStatus)}</td>
            <td>{(temp1 = insert.poStatus)}</td>

            <td>
              {insert.vendorStatus !== 'Approved' ? (
                temp === 'Rejected' ? (
                  ''
                ) : (
                  <button
                    type='button'
                    className='btn btn-secondary deca-btn-yellow '
                    // href={`/purchaseorder/${insert.vendorName}`}
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                    }}
                    onClick={() => this.handleEditStatus(insert)}
                    disabled={temp === 'Rejected'}
                  >
                    Approve
                  </button>
                )
              ) : (
                <button
                  type='button'
                  className='btn btn-secondary deca-btn-yellow'
                  //disabled={insert.poStatus === "Yes"}
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    cursor:
                      insert.poStatus === 'Yes' ? 'not - allowed' : 'pointer',
                  }}
                >
                  {insert.poStatus === 'Yes' ? (
                    <NavLink
                      to={{
                        pathname:
                          insert.poStatus === 'No'
                            ? `/projectTracker/purchaseorder`
                            : '',
                        state: {
                          title: insert.vendorName,
                        },
                      }}
                      style={{
                        color: 'white',
                        textDecoration: 'none',
                        cursor:
                          insert.poStatus === 'Yes'
                            ? 'not - allowed'
                            : 'pointer',
                      }}
                      onClick={() => this.viewPo(insert, this.state.title)}
                    >
                      {this.state.download ? 'Loading' : 'View PO'}
                    </NavLink>
                  ) : (
                    <NavLink
                      to={{
                        pathname:
                          insert.poStatus === 'No'
                            ? `/projectTracker/purchaseorder`
                            : '',
                        state: {
                          title: insert.vendorName,
                        },
                      }}
                      style={{
                        color: 'white',
                        textDecoration: 'none',
                        cursor:
                          insert.poStatus === 'Yes'
                            ? 'not - allowed'
                            : 'pointer',
                      }}
                      onClick={() => this.handlePo(insert, this.state.title)}
                    >
                      Generate PO
                    </NavLink>
                  )}
                </button>
              )}
            </td>
          </tr>
        );
      });
    } else {
      addvendor.push(
        <tr>
          <td colSpan={11} className='text-center'>
            No Vendors Data
          </td>
        </tr>
      );
    }

    return (
      <>
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        {modalOpen ? (
          <MessageBox
            message={message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}
        <div className='wrapper'>
          <Header title={this.state.title} />

          <Menu />
          <div className='content-wrapper'>
            {loading ? (
              <Spinner />
            ) : (
              <section className='content' style={{ width: '95%' }}>
                <div className='row '>
                  <ToastContainer
                    position='top-right'
                    autoClose={2000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    className=''
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                  />

                  <div className='row'>
                    <div className=''>
                      <button
                        type='button'
                        className='btn btn-secondary deca-btn-orange'
                        onClick={this.goBack}
                        style={{ cursor: 'pointer' }}
                      >
                        <i className='fa fa-arrow-left' aria-hidden='true'></i>
                      </button>
                    </div>
                    <div
                      style={{
                        marginBottom: '30px',
                      }}
                    >
                      {this.state.projectStatusReport !== 'Completed' || {
                        temp1,
                      } ? (
                        <AddVendor
                          addVendor={this.addVendor}
                          noOfVendors={this.state.loadVendors.vendorsInfo}
                        />
                      ) : (
                        <br />
                      )}
                    </div>
                    {this.state.vendorEditing ? (
                      <EditVendor
                        editing={this.state.vendorEditing}
                        setEditing={this.setEditing}
                        editVendorDetails={this.editVendorDetails}
                        vendorData={this.state.vendorData}
                      />
                    ) : (
                      ''
                    )}
                    {this.state.statusEditing ? (
                      <EditVendorStatus
                        editing={this.state.statusEditing}
                        statusData={this.state.statusData}
                        setStaEditing={this.setStaEditing}
                        editStatusDetails={this.editStatusDetails}
                      />
                    ) : (
                      ''
                    )}

                    <div className='col-md-12 backgr-custom'>
                      <table
                        className='table table-bordered table-hover table-striped '
                        style={{
                          borderCollapse: 'collapse',
                          display: 'block',
                          overflowX: 'auto',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <thead
                          className=''
                          style={{
                            backgroundColor: '#3c8dbc',
                            color: '#fff',
                            textAlign: 'left',
                          }}
                        >
                          <tr style={{ textAlign: 'left' }}>
                            <th>Vendor Name</th>
                            <th>Email</th>
                            <th>Contact Person</th>
                            <th>Address</th>
                            <th>GST No</th>
                            <th>Quote Cost</th>
                            <th>Quote Date</th>
                            <th>Created By</th>
                            <th>Status</th>
                            <th>PO</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className='mms'>{addvendor}</tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </section>
            )}
          </div>

          <Footer />
        </div>
      </>
    );
  }
}

export default Project;
